import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddFormStepButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/form_steps/create?form=${record['@id']}`}
    label="Add a form step"
    title="Add a form step"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddFormStepButton);
